import { render, staticRenderFns } from "./nav-list.vue?vue&type=template&id=e4ae9824&"
import script from "./nav-list.vue?vue&type=script&lang=ts&"
export * from "./nav-list.vue?vue&type=script&lang=ts&"
import style0 from "./nav-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports